<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">settings</v-icon>
			<v-toolbar-title>Ustawienia</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon color="white" class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Kraje</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-autocomplete
						:readonly="readOnlyMode"
						:items="volunteeringCountries"
						aria-label="volunteering country"
						label="Lista krajów, w których chcę odbyć pracę wolontariacką"
						for="other-profile-data-view-countries-list"
						id="other-profile-data-view-countries-list"
						item-text="name"
						item-value="API"
						multiple
						chips
						clearable
						deletable-chips
						hide-no-data
						v-model="data.preferredVolunteeringCountries"
						return-object
					></v-autocomplete>
				</v-flex>
			</v-layout>
			<v-layout row class="mb-2">
				<v-flex xs2/>
				<v-flex xs7>
					<v-switch
						v-model="data.presentOnList"
						aria-label="show me on the volunteers list"
						label="Wyświetlaj mnie na liście wolontariuszy"
						for="other-profile-data-view-display-me"
						id="other-profile-data-view-display-me"
						color="primary"
						hide-details
						:disabled="readOnlyMode"
						class="mb-4"
					></v-switch>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-text-field
						browser-autocomplete="off"
						v-model="data.volunteerCode"
						label="Kod wolontariusza"
						aria-label="volunteer code"
						for="other-profile-data-view-volunteer-code"
						id="other-profile-data-view-volunteer-code"
						outline readonly>
						<template slot="append">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon class="mt-2" @click="copyToClipboard" right v-on="on">file_copy</v-icon>
								</template>
								<span v-if="copiedToClipboard">Skopiowane</span>
								<span v-else>Kopiuj do schowka</span>
							</v-tooltip>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon class="mt-1 mr-2" @click="refreshVolunteerCode" right v-on="on"
										:disabled="readOnlyMode">
										refresh
									</v-icon>
								</template>
								<span>Generuj nowy kod</span>
							</v-tooltip>
						</template>
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	import {Profile} from "../../../../../api/generated/Profile";
	import {AccreditationCountry} from "../../../../../api/generated/AccreditationCountry";
	import {createLabels} from "../../../../../utils/createLabels";

	export default {
		name: "OtherProfileDataView",


		updated() {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},
		data() {
			return {
				copiedToClipboard: false,

				readOnlyMode: true,

				volunteeringCountries: [],

				data: {},
			};
		},

		methods: {
			copyToClipboard() {
				navigator.clipboard.writeText(this.data.volunteerCode);
				this.copiedToClipboard = true;
			},

			refreshVolunteerCode() {
				Profile.getGenerateVolunteerCode(this, response => {
					this.data.volunteerCode = response;
					this.copiedToClipboard = false;
				});
			},

			refresh() {
				AccreditationCountry.get(this, successResponse => {
						this.volunteeringCountries = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować kraje wolontariatu", errorResponse);
					});
			},
		},

		watch: {
			otherData: function () {
				this.data = this.otherData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		created() {
			this.refresh();
		},

		props: {
			otherData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>